import BaseController from "controllers/backend/base"
import React from 'react'
import ReactDOM from 'react-dom';
import Group from 'components/group/group';
const group = document.getElementById('group-container');

class Controller extends BaseController {
  call() {
    super.call()
    let user = gon.user
    ReactDOM.render( <Group user={user} />, group);
  }
};

export default Controller;
